export default "__VITE_ASSET__BDxKQKwP__"